module.exports = __webpack_public_path__ + "static/media/logo-sus.10a966ab.svg";